import styled from "styled-components";

export const container = styled.div`
    grid-area: container-right;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 5rem 4rem 5rem 0rem;

    .recent-transitions{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 20px;
        background: radial-gradient(#f1e8e7, #f6f5fa);
        padding: 7rem 2rem 2rem 2rem;
        position: relative;
        
        h3{
            font: 600 1.5rem 'Poppins', sans-serif;
            margin-bottom: 2.5rem;
            position: absolute;
            top: 3rem;
        }
    }

    .container-question{
        display: flex;
        justify-content: flex-end;
        margin-top: 6rem;

        
        .container-text{
            
            height: fit-content;
            padding: 1.5rem 0rem 1.5rem 1rem;
            border-radius: 10px;

            background: #FAF3F1;
            box-shadow: 0px 5px 5px 1px #FCE6E1;

            h3{
                color: #F46B45;
                font-size: 1.1rem;
            }

            p{
                font-size: 1.1rem;
            }
        }

        img{
            width: 14rem;
            height: auto;
        }
    }





    /* _______RESPONSIVIDADE__________ */

    @media (max-width: 567px){
        
        width: 100%;
        padding: 5rem 1rem;

        .recent-transitions{

            h3{
                font-size: 1.7rem;
            }
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            justify-content: center;
        }

        .container-question{
            width: 100%;
            justify-content: center;

            .container-text{
            h3{
                font-size: 1.5rem;
            }

            p{
                font-size: 1.5rem;
            }
        }

        img{
            width: 15rem;
            height: auto;
            }
        }
    }

    @media (min-width: 567px) and (max-width: 766.98px){

        width: 100%;
        padding: 5rem 2rem;

        .recent-transitions{
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            justify-content: center;
        }

        .container-question{
            width: 100%;
            justify-content: center;

            .container-text{
            h3{
                font-size: 1.5rem;
            }

            p{
                font-size: 1.5rem;
            }
        }

        img{
            width: 15rem;
            height: auto;
            }
        }
    }
    
    @media (min-width: 767.98px) and (max-width: 999px){

        width: auto;
        padding: 5rem 3.5rem;
        

        .recent-transitions{
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
        }

        .container-question{
            width: 100%;
            justify-content: center;

            .container-text{
            h3{
                font-size: 1.5rem;
            }

            p{
                font-size: 1.5rem;
            }
        }

        img{
            width: 15rem;
            height: auto;
            }
        }
        
    }
    

    @media (max-width: 999px){
        grid-area: 3 / 2 / 3 / 2;
    }


    @media (min-width: 999.98px) and (max-width: 1250px){
        width: min(32rem, 23vw);
        padding: 5rem 2rem 5rem 0rem;
        

        .recent-transitions{
            padding: 7rem 1.5rem 2rem 1.5rem;
        }

        .container-question{
            width: min(31rem, 23vw);
        }
    }

`